import React from 'react'
import { useTranslation } from 'react-i18next'

interface ActiveFiltersCounterProps {
    count: number
    className?: string
}

export const ActiveFiltersCounter: React.FC<ActiveFiltersCounterProps> = ({
    count,
    className = '',
}) => {
    const { t } = useTranslation('translations')

    if (count === 0) {
        return null
    }

    return (
        <div
            className={`rounded-full border border-blue-100 bg-blue-50 px-3 py-1 text-xs font-medium ${className} `}
            data-testid="active-filters-counter"
        >
            {count} {t('filters.active')}
        </div>
    )
}
